export default __webpack_public_path__ + "static/media/Blond Ale.0db8ebfb.png";